module.exports = __webpack_public_path__ + "static/media/sword-epic.977e68df.png";